export default {
    data() {
        return {
            // Kit Rental Disclosure
            kitInventory: undefined,
        }
    },

    computed: {
        getInventoryEndpoint() {
            if (! this.assignment.hash) return false;

            // Wrong use of mixin?
            if (typeof this.endpoints === 'undefined' && typeof this.type === 'undefined') {
                // need to handle
                return false;

            // There is no endpoint, but we know it's employer
            } else if (typeof this.endpoints === 'undefined' && this.type === 'employer') {
                return '/assignments/' + this.assignment.hash;

            // There is no endpoint, but we know it's employee
            } else if (typeof this.endpoints === 'undefined' && this.type === 'employee') {
                return '/employee/start/' + this.assignment.hash;

            // There is an endpoint, and we know it's employee/employer
            } else if (this.endpoints && this.type) {
                return this.endpoints.assignment;

            } else {
                return false;
            }
        },

        kitEndpoint () {
            return (this.getInventoryEndpoint) ? this.getInventoryEndpoint + '/kit' : false;
        },

        pdEndpoint () {
            return (this.getInventoryEndpoint) ? this.getInventoryEndpoint + '/pd' : false;
        },

        mileEndpoint () {
            return (this.getInventoryEndpoint) ? this.getInventoryEndpoint + '/mile' : false;
        },
    },

    methods: {
        // Inventory
        addKitInventory() {
            this.kitInventory = {
                description: 'Kit Rental Inventory for ' + this.assignment.employee,
                amount: (typeof this.assignment.kit_rental === 'undefined' && typeof this.assignment.kit_rental_tax === 'undefined') ? 0 : ((parseFloat(this.assignment.kit_rental || '0') + parseFloat(this.assignment.kit_rental_tax || '0')) || 0),
                type_id: 82,
                value: [],
            };
        },

        addKitInventoryLine() {
            if (!this.kitInventory) {
                this.addKitInventory();
            }

            this.kitInventory.value.push(
                {
                    quantity: 1,
                    description: '',
                    serial: '',
                    kitValue: '',
                    rentalRate: '',
                },
            );
        },

        loadKitInventory() {
            this.oasisApi.get(this.kitEndpoint)
                .then(response => {
                    if (response.status == 200 && response.data) {
                        this.kitInventory = response.data;
                    } else if (response.status == 200) {
                        this.addKitInventoryLine();
                    } else if (response.status == 400) {
                        this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); 
                });
        },

        clearKitInventory() {
            this.kitInventory = undefined;
        },

    },
}